'use client';

import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import { GlowModal, GlowTag, GlowTextBody, GlowTextBodySmall, PropsWithLocale } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { StringHelpers } from '@headless-workspace/utils';
import { MySephoraPushLoyaltyContent } from './MySephoraPushLoyaltyContent';
import styles from './loyalty.module.css';
import { VIP_BORDER_CLASSES } from './styles';

type PushLoyaltyModalContentProps = PropsWithLocale & {
    loyaltyPointsLabel: string;
    loyaltyPointsPerCurrency?: number;
    currency: string;
    isVipBrand: boolean;
    isMySephoraActivated: boolean;
};

export const PushLoyaltyModalContent: Component<PushLoyaltyModalContentProps> = ({
    loyaltyPointsLabel,
    loyaltyPointsPerCurrency,
    locale,
    currency,
    isVipBrand,
    isMySephoraActivated,
}) => {
    const t = useTranslations('Discover.Pdp.loyalty');

    const fidPointRulesLabel = t('label.fidPointRules', {
        value: StringHelpers.formatPrice({ price: loyaltyPointsPerCurrency, currency, locale, isInteger: true }),
    });

    if (isMySephoraActivated) {
        return <MySephoraPushLoyaltyContent loyaltyPointsLabel={loyaltyPointsLabel} />;
    }

    return (
        <GlowModal.Content contentClassName={'!gap-1'}>
            <GlowTextBody fontSize={'title5'} text={t('label.fidContent')} fontWeight={'bold'} TagName={'h3'} />
            <GlowTextBody text={fidPointRulesLabel} />

            <div
                className={clsx(
                    'flex flex-row gap-x-0.5',
                    isVipBrand ? VIP_BORDER_CLASSES : styles.customGradientFid,
                    'rounded-0.5 p-1.5',
                )}
            >
                <GlowTag label={loyaltyPointsLabel} color={'primaryGrey'} size={'large'} />
                <GlowTextBodySmall className={'flex flex-col justify-center'} text={t('label.fidAddToAccount')} />
            </div>
        </GlowModal.Content>
    );
};
